import { Button, Col, notification } from "antd";
import { useCallback, useState } from "react";
import OrgaoService from "../../../../../../services/http/services/SaldoDeContas/OrgaoService";
import { EmitirErro } from "../../../../../../services/EmitirErro";
import { IOrgaoManutencaoAtivacao } from "../../../interfaces";

interface IProps {
    orgao: IOrgaoManutencaoAtivacao | null;
}

export default function BotoesAtualizar({
    orgao,
}: IProps) {
    const [isSubmitingSaldo, setIsSubmitingSaldo] = useState(false);
    const [isSubmitingEmpenhos, setIsSubmitingEmpenhos] = useState(false);

    const handleClickBuscarSaldo = useCallback(async () => {
        if (!orgao) {
            return;
        }

        try {
            setIsSubmitingSaldo(true);
            await OrgaoService.buscarSaldo({ orgaoId: orgao.id });

            notification.success({
                message: 'Sucesso',
                description: 'Busca do saldo das contas iniciada com sucesso!',
            });
            setIsSubmitingSaldo(false);
        } catch (error) {
            EmitirErro(error, true, 'buscarSaldo_a80s0dnasd0asd');
            setIsSubmitingSaldo(false);
        }
    }, [orgao]);

    const handleClickBuscarEmpenhosERestos = useCallback(async () => {
        if (!orgao) {
            return;
        }

        try {
            setIsSubmitingEmpenhos(true);
            await OrgaoService.buscarEmpenhosERestos({ orgaoId: orgao.id });

            notification.success({
                message: 'Sucesso',
                description: 'Busca dos empenhos e restos iniciada com sucesso!',
            });
            setIsSubmitingEmpenhos(false);
        } catch (error) {
            EmitirErro(error, true, 'buscarEmpenhosERestos_a80s0dnasd0asd');
            setIsSubmitingEmpenhos(false);
        }
    }, [orgao]);

    return (
        <Col span={24}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                <Button
                    type='primary'
                    onClick={handleClickBuscarSaldo}
                    loading={isSubmitingSaldo}
                    disabled={isSubmitingSaldo}
                >
                    Buscar saldo
                </Button>

                <Button
                    type='primary'
                    onClick={handleClickBuscarEmpenhosERestos}
                    loading={isSubmitingEmpenhos}
                    disabled={isSubmitingEmpenhos}
                >
                    Buscar empenhos
                </Button>
            </div>
        </Col>
    )
}
